/**
 * `v3.host.*` — the loop host's own two calls, authenticated by its run token.
 *
 * Handlers: `v3-host.router.ts` (A-HOST).
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { HostAppendInput, HostAppendResult, HostSpec, HostSpecInput } from "@fm/v3/api";
import { Schema } from "effect";
import { DatabaseError, RecordNotFoundError, ValidationError } from "../errors.ts";
import { V3HostMiddleware } from "./v3-host.tags.ts";

const errors = Schema.Union(RecordNotFoundError, ValidationError, DatabaseError);

/**
 * @since 1.0.0
 */
export class V3HostRpcs extends RpcGroup.make(
  /** Everything the host needs to run, read once at start. */
  Rpc.make("v3.host.spec", { payload: HostSpecInput, success: HostSpec, error: errors }).middleware(V3HostMiddleware),
  /**
   * Append events (idempotent on seq), project `run.started` / `run.finished` /
   * `run.reviewed` onto the run row and its review, and push them to watchers.
   */
  Rpc.make("v3.host.append", { payload: HostAppendInput, success: HostAppendResult, error: errors })
    .middleware(V3HostMiddleware),
) {}
